<!-- <div class="row" style="margin: 0 10px;">
    <div class="col-md-12"> -->
        <div class="card">
            <div class="card-body">
                <form [formGroup]="userForm" novalidate>
                    <mat-form-field style="width: 0; height: 0;">
                        <input matInput hidden formControlName="id">
                    </mat-form-field>

                    <div class="row">
                        <!-- <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="{{this.translate.data['USERNAME'] | translate}}"  formControlName="userName" readonly>
                            </mat-form-field>                          
                        </div> -->
                        <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="Email" formControlName="email" readonly>
                            </mat-form-field>                            
                        </div>
                        <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="{{this.translate.data['PHONENUMBER'] | translate}} (für Mandanten)"  formControlName="phoneNumber">
                            </mat-form-field>                            
                        </div>
                    </div>  
                    <div class="row">
                        <div class="col-md-8">
                            <section class="example-full-width">
                                <mat-slide-toggle color="primary" formControlName="emailConfirmed" labelPosition="before">
                                    {{this.translate.data['EMAILCONFIRMED'] | translate}}
                                </mat-slide-toggle>
                            </section>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <section class="example-full-width">
                                <mat-slide-toggle color="primary"  formControlName="phoneNumberConfirmed" labelPosition="before">
                                    {{this.translate.data['PHONENUMBERCONFIRMED'] | translate}}
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
                    <!-- <div class="row" *ngIf="admin">
                        <div class="col-md-8">
                            <section class="example-full-width">
                                <mat-slide-toggle color="primary" formControlName="twoFactorEnabled" labelPosition="before">
                                    {{this.translate.data['TWOFACTORENABLED'] | translate}}
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
                    <div class="row" *ngIf="admin">
                        <div class="col-md-8">
                            <section class="example-full-width">
                                <mat-slide-toggle color="primary" formControlName="lockoutEnabled" labelPosition="before">
                                    {{this.translate.data['LOCKOUTENABLED'] | translate}}
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
                    <div class="row" *ngIf="admin">
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width">
                                <input matInput [matDatepicker]="pickeryear" placeholder="{{this.translate.data['DATEFORLOCKOUTEND'] | translate}}" formControlName="lockoutEnd">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="pickeryear"></mat-datepicker-toggle>
                                <mat-datepicker #pickeryear startView="year"></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div> -->
        
                    <button mat-raised-button  class="btn btn-squirrel pull-right" (click)="editUserInfo()">{{this.translate.data['MODIFY'] | translate}}</button>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    <!-- </div>
</div> -->





                    <!-- <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <input matInput hidden formControlName="id"> 
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <input  placeholder="{{this.translate.data['USERNAME'] | translate}}"  formControlName="userName" required>
                            </div>                          
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <input  placeholder="Email" formControlName="email" required>
                            </div>                            
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <input placeholder="{{this.translate.data['PHONENUMBER'] | translate}}"  formControlName="phoneNumber" required>
                            </div>                            
                        </div>
                    </div>  
                    <div class="row">
                        <div class="col-md-8">
                            <section div class="form-group">
                                <mat-slide-toggle color="primary" formControlName="emailConfirmed" labelPosition="before">
                                    {{this.translate.data['EMAILCONFIRMED'] | translate}}
                                </mat-slide-toggle>
                            </section>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <section div class="form-group">
                                <mat-slide-toggle color="primary"  formControlName="phoneNumberConfirmed" labelPosition="before">
                                    {{this.translate.data['PHONENUMBERCONFIRMED'] | translate}}
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
                    <div class="row" *ngIf="admin">
                        <div class="col-md-8">
                            <section div class="form-group">
                                <mat-slide-toggle color="primary" formControlName="twoFactorEnabled" labelPosition="before">
                                    {{this.translate.data['TWOFACTORENABLED'] | translate}}
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
                    <div class="row" *ngIf="admin">
                        <div class="col-md-8">
                            <section div class="form-group">
                                <mat-slide-toggle color="primary" formControlName="lockoutEnabled" labelPosition="before">
                                    {{this.translate.data['LOCKOUTENABLED'] | translate}}
                                </mat-slide-toggle>
                            </section>                        
                        </div>
                    </div>
                    <div class="row" *ngIf="admin">
                        <div class="col-md-8">
                            <div class="form-group">
                                <input matInput [matDatepicker]="pickeryear" placeholder="{{this.translate.data['DATEFORLOCKOUTEND'] | translate}}" formControlName="lockoutEnd">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="pickeryear"></mat-datepicker-toggle>
                                <mat-datepicker #pickeryear startView="year"></mat-datepicker>
                            </div>
                        </div>
                    </div> -->


